module["exports"] = [
  "Чтобы {{verb}} {{noun}}, мы можем получить {{abbreviation}} {{noun}} через {{adjective}} {{abbreviation}} {{noun}}!",
  "Необходимо {{verb}} {{adjective}} {{abbreviation}} {{noun}}!",
  "Попробуйте {{verb}} {{abbreviation}} {{noun}}, возможно это позволит {{verb}} {{adjective}} {{noun}}!",
  "Вы не можете {{verb}} {{noun}}, требуется {{ingverb}} или {{ingverb}}!",
  "Используйте {{adjective}} {{abbreviation}} {{noun}}, для того чтобы {{verb}} {{adjective}} {{noun}}!",
  "{{abbreviation}} {{noun}} недоступен, требуется {{verb}} {{adjective}} {{noun}}, чтобы мы могли {{verb}} {{abbreviation}} {{noun}}!",
  "{{ingverb}} не работает, попробуйте {{verb}} {{adjective}} {{abbreviation}} {{noun}}!",
  "Я планирую {{verb}} {{adjective}} {{abbreviation}} {{noun}}, это должно помочь {{verb}} {{abbreviation}} {{noun}}!"
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ru/hacker/phrase.js
// module id = 3531
// module chunks = 1609